import React from 'react';
import ErrorPage from 'components/ErrorPage';

const UnAuthorized = () => <ErrorPage code='404' msg='页面未找到' />;

export default React.memo(UnAuthorized);
